import React from 'react';
import { Loader } from './Loader';
import { PaystackButton } from 'react-paystack';
import apiConfig from 'constants/apiConfig';
import { PaystackSuccessDto } from 'service/dto/payment.dto';

type Props = {
  isProcessing: boolean;
  onPaymentSuccess: (paystackSuccessDto: PaystackSuccessDto) => void;
  onPaymentClose: () => void;
  reference: string;
  email: string;
  amount: number;
};

export default function Paystack({
  isProcessing,
  onPaymentSuccess,
  onPaymentClose,
  reference,
  email,
  amount
}: Props) {
  return (
    <div>
      {isProcessing ? (
        <Loader color={'#FF6606'} height={50} width={50} />
      ) : (
        <PaystackButton
          onSuccess={onPaymentSuccess}
          onClose={onPaymentClose}
          reference={reference}
          email={email}
          amount={amount * 100}
          publicKey={apiConfig.paystack_key}
          className="mb-3 w-[11rem] rounded bg-emerald-700 p-[0.5rem] text-white"
          text="Proceed to Paysatck"
        />
      )}
    </div>
  );
}
